import ReactGA from "react-ga4";

const track = (name, params = {}) => {
  try {
    ReactGA.event(name, params);
  } catch (err) {
    if (process.env.NODE_ENV !== "production") console.warn("GA event failed", name, err);
  }
};

export const trackCalculatorUse = (calculator, params = {}) =>
  track("calculator_use", { calculator, ...params });

export const trackSearch = (searchTerm, params = {}) =>
  track("search", { search_term: searchTerm, ...params });

export const trackFilter = (filterType, value, params = {}) =>
  track("filter_apply", { filter_type: filterType, filter_value: String(value), ...params });

export const trackViewToggle = (view, params = {}) =>
  track("view_toggle", { view, ...params });

export const trackItemSelect = (itemName, itemType, params = {}) =>
  track("select_item", { item_name: itemName, item_type: itemType, ...params });

export const trackToolNavigation = (toolName, sourcePage) =>
  track("tool_navigation", { tool: toolName, source_page: sourcePage });

export const trackOutboundClick = (destination, url) =>
  track("outbound_click", { destination, link_url: url });

export const trackDonateClick = (option, amount) =>
  track("donate_click", { donation_option: option, value: amount || 0 });

export const trackSocialAction = (action, params = {}) =>
  track("social_action", { social_action: action, ...params });

export default {
  trackCalculatorUse,
  trackSearch,
  trackFilter,
  trackViewToggle,
  trackItemSelect,
  trackToolNavigation,
  trackOutboundClick,
  trackDonateClick,
  trackSocialAction,
};
